import { createContext } from 'react';

export const DisconnectPixelModalContext = createContext({
  open: (pixelId: string) => {},
});
